import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CaseState {
  caseid: any;
  claimnumber: string;
  status: boolean;
  caseStage: any;
  CaseTypeName: any;
  caseReviewTypeName: any;
  caseInfoId: any;
  isSearchEditable: boolean;
  clientId: any;
  isUploadFile: boolean;
  isCancelFiles: boolean;
  isDashboard: boolean;
  newCaseInFoID: any;
  client_stakeholderId: any;
  isInjuryAvailable: boolean;
  isRecordAvailable: boolean;
  isQMEScheduleAvailable: boolean;
  isBillingAvailable: boolean;
  isViewSchedule: boolean;
  patientDetails: string;
}

const initialState: CaseState = {
  caseid: "",
  claimnumber: "",
  status: false,
  caseStage: "",
  caseInfoId: null,
  CaseTypeName: "",
  caseReviewTypeName: "",
  isSearchEditable: false,
  clientId: "",
  isUploadFile: false,
  isCancelFiles: false,
  isDashboard: false,
  newCaseInFoID: null,
  client_stakeholderId: null,
  isInjuryAvailable: false,
  isRecordAvailable: false,
  isQMEScheduleAvailable: false,
  isBillingAvailable: false,
  isViewSchedule: false,
  patientDetails: "",
};

const CaseHeaderSlice = createSlice({
  name: "case_header",
  initialState,
  reducers: {
    setCaseId: (state, action: PayloadAction<any>) => {
      state.caseid = action.payload;
    },
    setClaimNumber: (state, action: PayloadAction<string>) => {
      state.claimnumber = action.payload;
    },
    setStatus: (state, action: PayloadAction<boolean>) => {
      state.status = action.payload;
    },
    setCaseStage: (state, action: PayloadAction<any>) => {
      state.caseStage = action.payload;
    },
    setCaseTypeName: (state, action: PayloadAction<any>) => {
      state.CaseTypeName = action.payload;
    },
     setcaseReviewTypeName: (state, action: PayloadAction<any>) => {
      state.caseReviewTypeName = action.payload;
    },
    setCaseInfoId: (state, action: PayloadAction<any>) => {
      state.caseInfoId = action.payload;
    },
    setIsSearchEditable: (state, action: PayloadAction<any>) => {
      state.isSearchEditable = action.payload;
    },
    setClientId: (state, action: PayloadAction<any>) => {
      state.clientId = action.payload;
    },
    setIsUploadFile: (state, action: PayloadAction<boolean>) => {
      state.isUploadFile = action.payload;
    },
    setIsCancelFiles: (state, action: PayloadAction<boolean>) => {
      state.isCancelFiles = action.payload;
    },
    setIsDashboard: (state, action: PayloadAction<boolean>) => {
      state.isDashboard = action.payload;
    },
    setNewCaseInFoID: (state, action: PayloadAction<any>) => {
      state.newCaseInFoID = action.payload;
    },
    setClient_StakeholderId: (state, action: PayloadAction<any>) => {
      state.client_stakeholderId = action.payload;
    },
    setInjuryAvailable: (state, action: PayloadAction<boolean>) => {
      state.isInjuryAvailable = action.payload;
    },
    setRecordAvailable: (state, action: PayloadAction<boolean>) => {
      state.isRecordAvailable = action.payload;
    },
    setQMEScheduleAvailable: (state, action: PayloadAction<boolean>) => {
      state.isQMEScheduleAvailable = action.payload;
    },
    setBillingAvailable: (state, action: PayloadAction<boolean>) => {
      state.isBillingAvailable = action.payload;
    },
    setIsViewSchedule: (state, action: PayloadAction<boolean>) => {
      state.isViewSchedule = action.payload;
    },
    setPatientDetails: (state, action: PayloadAction<string>) => {
      state.patientDetails = action.payload;
    },
  },
});

export const {
  setCaseId,
  setClaimNumber,
  setStatus,
  setCaseStage,
  setCaseInfoId,
  setCaseTypeName,
  setcaseReviewTypeName,
  setIsSearchEditable,
  setClientId,
  setIsUploadFile,
  setIsCancelFiles,
  setIsDashboard,
  setNewCaseInFoID,
  setClient_StakeholderId,
  setInjuryAvailable,
  setRecordAvailable,
  setQMEScheduleAvailable,
  setBillingAvailable,
  setIsViewSchedule,
  setPatientDetails,
} = CaseHeaderSlice.actions;
export default CaseHeaderSlice.reducer;
